module.exports = __webpack_public_path__ + "static/media/tokiwa10-7.bcd07e32.jpg";